export const updateTheme = (theme) => ({
    type:'UPDATE_THEME',
    payload:theme,
});